import React from 'react';
import styled from 'styled-components';
import GoogleIcon from 'resources/icons/google_icon.png'
import GoogleLoginButton from 'resources/google_signin_dark.png'

import classes from './GoogleButton.module.css'

const GoogleButton = props => {
    const {
        onSelect,
        text
    } = props;
    const googleIcon = <img src={GoogleIcon} style={{width:'18px', height:'18px',objectFit:'contain'}}/>
    return (
        <div className={classes.Container} onClick={onSelect}>
            <div className={classes.Icon}>{googleIcon}</div>
            <div className={classes.Text}>{text}</div>
        </div>
    )
}

export default GoogleButton;